import React from 'react';
import { BinContext, BinContextProps } from '../context/BinContext';
import { Bin } from '../types/bin/bin';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';

const binState = {
  items: new Map<string, Bin>(),
  loading: false,
};

export const binSlice = createSlice({
  name: 'bin',
  initialState: { key: v4() },
  reducers: {
    reset: state => {
      binState.items = new Map();
      binState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<Bin[]>) => {
      binState.items = new Map();
      action.payload.forEach(p => binState.items.set(p.id, new Bin(p)));
      state.key = v4();
    },
    add: (state, action: PayloadAction<Bin[]>) => {
      action.payload.forEach(p => binState.items.set(p.id, new Bin(p)));
      binState.items = new Map(binState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<Bin[]>) => {
      action.payload.forEach(p => binState.items.delete(p.id));
      binState.items = new Map(binState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      binState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface BinProviderProps {
  children: React.ReactNode;
}

export default function BinProvider({ children }: BinProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.bins.key);

  const binContext: BinContextProps = {
    bins: binState.items,
    binsLoading: binState.loading,
    setBins: (bins: Map<string, Bin>) => {
      dispatch(binSlice.actions.set([...bins.values()]));
    },
  };

  return <BinContext.Provider value={binContext}>{children}</BinContext.Provider>;
}
